import { Component, Inject, OnInit, OnDestroy, Injectable } from '@angular/core';
import { DwAction, DwActionType, DwButtonType, DwActionHandler, DwMdFormActionState,
         DwActionResult, DwConfigServiceToken, DwConfigService } from '@devwareapps/devware-cap';
import { AdminManagerService } from '../../../features/admin/services/admin-manager.service';
import { AppMetaDataItemNames, ProcessorConfigEntity } from '../../../meta-data/app-meta-data.service';
import { Observable, of } from "rxjs";
import { PaymentsRepositoryService } from "src/app/features/payments/services/payments-repository.service";
import { HttpClient } from "@angular/common/http";
import { map, mergeMap } from 'rxjs/operators';
import { AviatorUser } from '../../shared/models/aviator-user.model';

@DwAction({
    keyName: 'createConnectedAccount',
    display: 'Enable Profit Sharing',
    actionType: DwActionType.formAction,
    isGlobal: false,
    parentItemName: [AppMetaDataItemNames.FlightSchool,AppMetaDataItemNames.ProcessorConfig],
    actionMessage: 'Setting up Stripe Connect...',
    defaultButtonConfig: {
        useParentDisplay: false,
        buttonText: 'Enable Profit Sharing',
        buttonType: DwButtonType.standard,
        buttonClass: 'btn btn-primary',
        iconClass: 'fa fa-sack-dollar',
    },
})
@Injectable()
export class EnabledProfitSharingActionService implements DwActionHandler {
    paymentsApi: string;
    accountReady: boolean= false;
    aviatorUser: AviatorUser;
    processorConfig: ProcessorConfigEntity = undefined;
    constructor(
        private http: HttpClient,
        private paymentsRepoSvc: PaymentsRepositoryService,
        private adminManagerService: AdminManagerService,       
        @Inject(DwConfigServiceToken) private configService: DwConfigService) 
    { 
        this.paymentsApi = `${configService.coreConfig.apiRoot}/aviator-online/Payments`;
    }

    handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
        return this.http.get<CreateAccountLink>(`${this.paymentsApi}/profit-sharing-link`)
                    .pipe(mergeMap(link => {
                        if (link.success && link.enabled != true && link.link?.length > 0)
                            window.open(link.link, '_createLink');
                        return of({ success: link.success, message: link.message });
                    }));
    }
}
export interface CreateAccountLink {
    success?: boolean,
    link?: string,
    message?: string,
    enabled?: boolean
}
  